import { FunctionalAsset } from '@synergy/models';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { Table, TableCell, TableRow, styled } from '@mui/material';
import { fields } from '@synergy/utils';

import { FunctionalAssetAutocomplete } from '../shared-components/functional-asset-autocomplete';
import { OrderDataFormValues } from '../../shopping-cart-page';
import { RowArticleMobile } from './row-article-mobile';
import { RowSumSupplierMobile } from './row-sum-supplier-mobile';
import { ShoppingCartSupplier } from '../../../../models/shopping-cart';
import { SupplierTableBody } from '../../../../components/supplier-table/supplier-table-body';
import { SupplierTableHead } from '../../../../components/supplier-table/supplier-table-head';
import { currencySelector } from '../../../../store/configuration-selectors';
import { updateFunctionalAsset } from '../../../../store/shopping-cart-actions';
import { useAppDispatch, useAppSelector } from '../../../../../store/store';

const StyledTable = styled(Table)(() => ({
    '& tr:last-child th, & tr:last-child td': {
        borderBottom: 'none',
    },
}));

export interface SupplierTableProps {
    supplier: ShoppingCartSupplier;
}

export const SupplierTableMobile = (props: SupplierTableProps): ReactElement => {
    const { supplier } = props;
    const dispatch = useAppDispatch();
    const currency = useAppSelector(currencySelector);
    const fieldNames = fields<OrderDataFormValues>();

    const handleFunctionalAssetChanged = (value: FunctionalAsset | null): void => {
        if (value !== null) {
            dispatch(updateFunctionalAsset(supplier.id, value.id));
        }
    };

    return (
        <StyledTable>
            <SupplierTableHead>
                <TableRow>
                    <TableCell>
                        <PoolTypography typography="subtitle1" sx={{ fontWeight: 600 }}>
                            {supplier?.name}
                        </PoolTypography>
                    </TableCell>
                </TableRow>
            </SupplierTableHead>
            {supplier.requireFunctionalAssets && (
                <TableRow sx={{ background: theme => theme.palette.grey[100] }}>
                    <TableCell>
                        <FunctionalAssetAutocomplete
                            name={fieldNames.functionalAssets + `[${supplier.id}]`}
                            supplierId={supplier.id}
                            required={true}
                            sx={{ width: '343px' }}
                            onValueChange={handleFunctionalAssetChanged}
                        />
                    </TableCell>
                </TableRow>
            )}
            <SupplierTableBody>
                {supplier.items.map(item => (
                    <RowArticleMobile
                        cartItem={item}
                        key={item.product.id}
                        previewImage={item.previewImage?.['200x200'] ?? supplier.image?.['200x200']}
                    />
                ))}
                <RowSumSupplierMobile supplier={supplier} currency={currency} />
            </SupplierTableBody>
        </StyledTable>
    );
};
